(function () {
    'use strict';

    var companyService = function ($http) {

        this.addEnvironment = function (companyId, displayName, uniqueId, ssoClientId) {
            return $http.post('api/company/addEnvironment', { companyId: companyId, displayName: displayName, uniqueId: uniqueId, ssoClientId: ssoClientId }).then(function (response) {
                          return response;
                    },
                    function () {
                        throw ('Companies Add environment failure');
                    });
        };
        this.addEmailDomain = function (companyId, emailDomain) {
            return $http.post('api/company/addEmailDomain', { companyId: companyId, emailDomain: emailDomain }).then(function (response) {
                          return response;
                    },
                    function () {
                        throw ('Companies Add domain failure');
                    });
        };
        this.removeEmailDomain = function (companyId, emailDomain) {
            return $http.post('api/company/removeEmailDomain', { companyId: companyId, emailDomain: emailDomain }).then(function (response) {
                          return response;
                    },
                    function () {
                        throw ('Companies Remove domain failure');
                    });
        };
        this.addIpAddress = function (companyId, ipAddress) {
            return $http.post('api/company/addIpAddress', { companyId: companyId, ipAddress: ipAddress }).then(function (response) {
                          return response;
                    },
                    function () {
                        throw ('Companies Add ip failure');
                    });
        };
        this.removeIpAddress = function (companyId, ipAddress) {
            return $http.post('api/company/removeIpAddress', { companyId: companyId, ipAddress: ipAddress }).then(function (response) {
                          return response;
                    },
                    function () {
                        throw ('Companies Remove ip failure');
                    });
        };
        this.disableImpersonation = function (companyId) {
            return $http.post('api/company/disableimpersonation/' + companyId, { }).then(function (response) {
                       

                    return response;
                    },
                    function () {
                        throw ('Companies Disable Impersonation Failure');
                    });
        };
        this.deactivateCompany = function (companyId) {
            return $http.post('api/company/deactivateCompany/' + companyId, { }).then(function (response) {
                       

                    return response;
                    },
                    function () {
                        throw ('Companies Deactivation Failure');
                    });
        };
        this.reactivateCompany = function (companyId) {
            return $http.post('api/company/reactivateCompany/' + companyId, { }).then(function (response) {
                       

                    return response;
                    },
                    function () {
                        throw ('Companies Reactivation Failure');
                    });
        };

        this.getCompanies = function (name, page, take) {
            return $http.post('api/company/list',
                {
                    name: name,
                    page: page,
                    take: take
                })
                .then(function (response) {
                    var items = response.data;

                    return items;
                },
                function () {
                    throw ('Companies Retrieval Failure');
                });
        };

        this.getCompanyById = function (id) {
            return $http.get('api/company/' + id)
                .then(function (response) {
                    var company = response.data;

                    return company;
                },
                function () {
                    throw ('Company Retrieval Failure');
                });
        };

        this.saveCompany = function (company) {
            return $http.post('api/company/save',
                company
            )
                .then(function (response) {
                    var company = response.data;
                    return company;
                },
                function () {
                    throw ('Error Updating Company');
                });
        }
        this.createCompany = function (company) {
            return $http.post('api/company/create',
                company
            )
                .then(function (response) {
                    var company = response.data;
                    return company;
                },
                function (response) {
                    throw (response.data.message);
                });
        }
        this.saveCompanyDetails = function (companyId, companyName, dynamicsId, workbooksOrganisationId, workbooksOrganisationName, partnerCode) {
            return $http.post('api/company/saveDetails', { companyId: companyId, companyName: companyName, dynamicsId: dynamicsId, workbooksOrganisationId: workbooksOrganisationId, workbooksOrganisationName: workbooksOrganisationName, partnerCode: partnerCode }).then(function (response) {
                    var company = response.data;
                    return company;
                },
                function () {
                    throw ('Error Updating Company details');
                });
        }

        this.checkDomain = function (domain) {
            return $http.get('api/company/checkdomain?domain=' + domain)
                .then(function (response) {
                    var errors = response.data;
                    return errors;
                },
                function () {
                    throw ('Error checking domain');
                });
        }

        this.checkIpAddress = function (ipAddress) {
            return $http.get('api/company/checkIpAddress?ipAddress=' + ipAddress)
                .then(function (response) {
                    var errors = response.data;
                    return errors;
                },
                function () {
                    throw ('Error checking domain');
                });
        }

        this.showProduct = function (companyId, clientId) {
            return $http.post('api/company/showProduct',
                {
                    companyId: companyId,
                    clientId: clientId
                }
            )
                .then(function (response) {
                    var data = response.data;
                    return data;
                },
                function () {
                    throw ('Error showing product');
                });
        }

        this.hideProduct = function (companyId, clientId) {
            return $http.post('api/company/hideProduct',
                {
                    companyId: companyId,
                    clientId: clientId
                }
            )
                .then(function (response) {
                    var data = response.data;
                    return data;
                },
                function () {
                    throw ('Error hiding product');
                });
        }

        this.createEnvironment = function(companyId, clientId, displayName) {
            return $http.post('api/company/createEnvironment',
                    {
                        companyId: companyId,
                        clientId: clientId,
                        displayName: displayName
                    }
                )
                .then(function(response) {
                        var data = response.data;
                        return data;
                    },
                    function() {
                        throw ('Error creating environment');
                    });
        };
        this.updateIntegrationCredentials = function (environmentId, username, password) {
            return $http.post('api/company/updateintegrationcredentials',
                    {
                        environmentId: environmentId,
                        username: username,
                        password: password
                    }
                )
                .then(function (response) {
                        var data = response.data;
                        return data;
                    },
                    function () {
                        throw ('Error updating credentials');
                    });
        }
    }

    angular.module('app')
        .service('companyService', ['$http', companyService]);
})();